enum AggregationFunction {
	sum = "sum",
	avg = "avg",
	min = "min",
	max = "max",
	size = "size",
}

type AggregationModel = Record<string, AggregationFunction>;

enum FormattedBoolean {
	Y = "Y",
	N = "N",
}

namespace FormattedBoolean {
	export const allValues = Object.values(FormattedBoolean) as string[];
}

enum RO_Status {
	New = "N",
	Finalized = "F",
	Void = "V",
	NoJobs = "X",
}

namespace RO_Status {
	export const allValues = Object.values(RO_Status).filter((value) => typeof value === "string") as string[];

	export function getColor(status: string): string {
		switch (status) {
			case RO_Status.New:
				return "primary";
			case RO_Status.Finalized:
				return "success";
			case RO_Status.Void:
				return "alert";
			case RO_Status.NoJobs:
				return "warning";
			default:
				return "";
		}
	}
}

enum FnI_ERA_DEAL_LEASE_STATUS {
	Saved = "S",
	SpotDelivered = "E",
	ClosedInFI = "C",
	FinalizedInAccounting = "F",
}

enum FnI_POWER_DEAL_LEASE_STATUS {
	InitialStatus = "SPACE",
	ClosedInFI = "C",
	Reopened = "D",
	FinalizedInAccounting = "I",
	Voided = "V",
}

const fnIStatusColorMap: Record<string, string> = {
	[FnI_ERA_DEAL_LEASE_STATUS.FinalizedInAccounting]: "success",
	[FnI_POWER_DEAL_LEASE_STATUS.FinalizedInAccounting]: "success",
	[FnI_ERA_DEAL_LEASE_STATUS.ClosedInFI]: "primary",
	[FnI_POWER_DEAL_LEASE_STATUS.Reopened]: "primary",
	[FnI_ERA_DEAL_LEASE_STATUS.Saved]: "warning",
	[FnI_ERA_DEAL_LEASE_STATUS.SpotDelivered]: "warning",
	[FnI_POWER_DEAL_LEASE_STATUS.InitialStatus]: "warning",
	[FnI_POWER_DEAL_LEASE_STATUS.Voided]: "alert",
};

namespace FnI_Status {
	export const allValues: string[] = Object.values(fnIStatusColorMap);
	export const getFIClosedStatusColor = (status: string): string => {
		return fnIStatusColorMap[status] || "default";
	};
}

export type { AggregationModel };
export { AggregationFunction, FormattedBoolean, RO_Status, FnI_Status };
